import { render, staticRenderFns } from "./OrderDetailScreen.vue?vue&type=template&id=387d5718&scoped=true&"
import script from "./OrderDetailScreen.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailScreen.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailScreen.vue?vue&type=style&index=0&id=387d5718&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d5718",
  null
  
)

export default component.exports